import type { LastPath } from "api/interfaces/authInterface.interface";
import type { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";

/** 현재 조직 + parentAccount 에 나오는 모든 조상 accountId (본인 포함) */
export function getAncestorAccountIds(
  account: ProfileAccountInfo
): Set<string> {
  const ids = new Set<string>();
  if (account.accountId) {
    ids.add(account.accountId);
  }
  for (const p of account.parentAccount ?? []) {
    if (p?.accountId) {
      ids.add(p.accountId);
    }
  }
  return ids;
}

/**
 * lastPath: 최신 방문이 배열 앞.
 * 새 current의 조상 체인에 속하지 않는 항목(형제 가지 등)은 제거한 뒤,
 * 현재 계정 + userType 을 선두에 둔다.
 */
export function mergeLastPathForAccountSwitch(
  previousPath: LastPath[],
  selectedAccount: ProfileAccountInfo,
  userType: string
): LastPath[] {
  if (!selectedAccount.accountId) {
    return previousPath;
  }
  const ancestorIds = getAncestorAccountIds(selectedAccount);
  const tail = previousPath.filter(
    (entry) =>
      ancestorIds.has(entry.accountId) &&
      entry.accountId !== selectedAccount.accountId
  );
  const head: LastPath = {
    accountId: selectedAccount.accountId,
    userType,
    accountLevel: selectedAccount.accountLevel,
  };
  return [head, ...tail];
}

export interface GetRoleIdProps {
  accountId?: string;
}

export const getRoleId = (props?: GetRoleIdProps): string => {
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.get("r")) {
    if (searchParams.get("r") === localStorage.getItem("r-hid")) {
      return localStorage.getItem("r-hid") as string;
    } else if (searchParams.get("r") === localStorage.getItem("r-mem")) {
      return localStorage.getItem("r-mem") as string;
    }
  }
  return ""
};

// const account = selectedAccountRef.current;
// if (!account.accountId) {
//   return;
// }

// const sp = new URLSearchParams(window.location.search);
// const urlAccountId = sp.get("account");
// if (
//   urlAccountId !== null &&
//   urlAccountId !== "" &&
//   urlAccountId !== account.accountId
// ) {
//   return;
// }

// let userType = getRoleId({
//   accountId: urlAccountId as string,
// });

// let previousPath: LastPath[] = [];
// try {
//   previousPath = JSON.parse(
//     sessionStorage.getItem("lastPath") ?? "[]"
//   ) as LastPath[];
// } catch {
//   previousPath = [];
// }

// const nextPath = mergeLastPathForAccountSwitch(
//   previousPath,
//   account,
//   userType
// );
// sessionStorage.setItem(
//   "userType",
//   JSON.stringify(nextPath.at(-1) as LastPath)
// );
// sessionStorage.setItem("lastPath", JSON.stringify(nextPath));
// localStorage.setItem("ut", JSON.stringify(nextPath.at(-1) as LastPath));